import Vue from 'vue'
 
/**
 * 定义空的vue实例，作为 goBackEntity实现非父子组件之间的通信(vue2.x中去掉了broadcast)
 * 用于传递一级表格列表页和二级修改页之间的参数传递
 */
var goBackData = new Vue({});

export default goBackData;